/**
 * A ordem que um LINK pode pedir para a Carteira. Função PURA.
 *
 * Existe para o bloco de pontualidade da Visão executiva abrir a lista de uma célula com
 * as OPs que estouram o prazo em cima: lá a pergunta é "quais não saem no prazo", e a
 * carteira ordenada pelo maior atraso não responde isso quando a célula não tem atraso
 * nenhum ainda registrado.
 *
 * Sem o parâmetro, cada aba mantém a ordem própria dela: este arquivo não muda nada da
 * tela, só dá nome ao que o link pode pedir.
 */

/** A chave na barra de endereço: `/ops?ordem=FORA_DO_PRAZO`. */
export const ORDEM_KEY = 'ordem';

/** A única ordem que o link oferece: maior exposição em risco primeiro. */
export const ORDEM_FORA_DO_PRAZO = 'FORA_DO_PRAZO';

/** A ordem pedida, ou `''` quando ninguém pediu ordem nenhuma. */
export type TOpsOrdem = typeof ORDEM_FORA_DO_PRAZO | '';

/** O link é digitável, então um valor que a tela não conhece simplesmente não ordena. */
export function parseOpsOrdem(raw: string): TOpsOrdem {
  return raw.trim().toUpperCase() === ORDEM_FORA_DO_PRAZO ? ORDEM_FORA_DO_PRAZO : '';
}
